// @ts-ignore
import SlimApi from '@/util/slimapi'
// @ts-ignore
import Api from '@/util/api'
// @ts-ignore
import $store from '@/store/index'
import { Exchange, Fastbot, FastbotData } from '@/util/types'
// @ts-ignore
import Constants from '@/util/constants'

export default {
  fbotdata: ($store.state.fastbot as FastbotData),

  updateList () {
    const params = {
      params: {
        // @ts-ignore
        token: $store.state.sys.token,
        // @ts-ignore
        etid: this.fbotdata.exchTokenId,
        status: this.fbotdata.type,
        page: this.fbotdata.page
      }
    }
    // console.log('updateList', params)
    SlimApi.get('fastbot/list', params)
      .then((response: any) => {
        // console.log('updateList:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            this.fbotdata.list = response.data
            if (this.fbotdata.list.length < 10) {
              this.fbotdata.lastPage = true
            }
            // update selected
            if (this.fbotdata.selected !== undefined) {
              this.fbotdata.list.forEach((fbot: Fastbot) => {
                if (this.fbotdata.selected!.Id === fbot.Id) {
                  this.fbotdata.selected = fbot
                }
              })
            }
          } else {
            console.log(response.data.err)
          }
        } else {
          if (this.fbotdata.page !== 0) {
            this.fbotdata.page -= 1
            this.fbotdata.lastPage = true
          } else {
            this.fbotdata.list = []
          }
        }
      }).catch((error: any) => {
      // error
        console.log(error)
      })
  },

  getFastbotExcOrders () {
    if (this.fbotdata.selected === undefined) {
      this.fbotdata.excOrders = []
      // console.log('getFastbotExcOrders:undefined')
      return
    }
    const params = {
      params: {
        token: $store.state.sys.token,
        etid: this.fbotdata.exchTokenId,
        fbot_id: this.fbotdata.selected!.Id
      }
    }
    SlimApi.get('fastbot/orders', params)
      .then((response: any) => {
        // console.log('getFastbotExcOrders:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            if (this.isDataChanged(this.fbotdata.excOrders, response.data)) {
              this.fbotdata.excOrders = response.data
            }
          } else {
            // error
            console.log(response.data.err)
          }
        } else {
          this.fbotdata.excOrders = []
        }
      }).catch((error: any) => {
      // error
        console.log(error)
      })
  },

  isDataChanged (olddata: any[], newdata: any[]) {
    if (newdata.length !== olddata.length) {
      return true
    }
    for (let i = 0; i < newdata.length; i++) {
      if (JSON.stringify(newdata[i]) !== JSON.stringify(olddata[i])) {
        return true
      }
    }
    return false
  },

  updateFastbotBalance () {
    if (this.fbotdata.exchTokenId === '') {
      return
    }
    setTimeout(() => {
      Api.get('asset/balance?token=' + $store.state.sys.token + '&etid=' + this.fbotdata.exchTokenId + '&symbol=' + this.fbotdata.asset + '_USDT')
        .then((response: any) => {
          this.fbotdata.freeBal = response.data.QAssetFree
          this.fbotdata.markPrice = response.data.LastPrice
          // console.log('last price updated: ', this.fbotdata.markPrice)
          // console.log('balance updated: ', this.fbotdata.freeBal)
        })
        .catch(function (error: string) {
          console.log(error)
        })
    }, 1000)
  },

  updateFastbotSymbols () {
    return Api
      .get('exch/symbols?token=' + $store.state.sys.token + '&eid=BIF')
      .then((response:any) => {
        // console.log('updateSymbols done1')
        this.fbotdata.symbolsfilter = {}
        if (response.data.Symbols) {
          this.fbotdata.symbols = response.data.Symbols.filter((item:any) => item.quoteAsset !== 'BUSD')
          response.data.Symbols.forEach((item:any) => {
            this.fbotdata.symbolsfilter[item.baseAsset + '_' + item.quoteAsset] = item
          })
        }
        // if (payload && payload.z) {
        //   payload.z()
        // }
      })
      .catch(function (error: string) {
        console.log(error)
      })
  },

  async updateFastbotExchangeAsync () {
    try {
      const params = {
        params: {
          token: $store.state.sys.token,
          demo: '0'
        }
      }
      const response = await Api.get('user/info', params)
      if (response.status === Constants.http.OK) {
        // console.log('response.data.Email:', response.data.Email)
        $store.state.sys.email = response.data.Email
        this.fbotdata.exchTokenLoaded = true
        if (response.data.exchanges) {
          const exchanges: Exchange[] = []
          const exchangesIds: string[] = []
          response.data.exchanges.forEach((exch: Exchange) => {
            if (exch.ExchId === 'BIF') {
              exchanges.push(exch)
              exchangesIds.push(exch.Id)
            }
          })
          this.fbotdata.exchanges = exchanges
          if (this.fbotdata.exchTokenId === '') {
            const id = localStorage.getItem('capico_app_booster_exchange')
            if (id) {
              this.fbotdata.exchTokenId = id
            }
          }
          if (exchanges.length === 0 && this.fbotdata.exchTokenId !== '') {
            this.fbotdata.exchTokenId = ''
            localStorage.setItem('capico_app_booster_exchange', '')
          }
          if (exchanges.length > 0 && !exchangesIds.includes(this.fbotdata.exchTokenId)) {
            this.fbotdata.exchTokenId = exchanges[0].Id
            localStorage.setItem('capico_app_booster_exchange', exchanges[0].Id)
          }
          // console.log('this.fbotdata.exchTokenId:', this.fbotdata.exchTokenId)
          // console.log('exchanges:', this.fbotdata.exchanges)
        }
      }
    } catch (err) {
      console.log(err)
    }
  },

  setFastbotAsset (asset: string) {
    this.fbotdata.asset = asset
    localStorage.setItem('capico_app_fastbotAsset', asset)
  }
}
